// extracted by mini-css-extract-plugin
module.exports = {"form":"device-type-settings-modal_form__1UQ0P"};